import React, { useEffect, useState } from 'react'

const Banner = ({ path }) => {

  const [title, setTitle] = useState("")

  useEffect(() => {
    switch (path) {
      case "/home":
        setTitle("MI CARPETA")
        break
      case "/detallePersonal":
        setTitle("MI CARPETA")
        break
      case "/admin":
        setTitle("ADMINISTRACION")
        break
      case "/carrera":
        setTitle("RECONOCIMIENTO DE NIVEL DE CARRERA")
        break
      case "/concursos":
        setTitle("CONCURSO DE TRASLADO")
        break
      case "/adquisicion":
        setTitle("ADQUISICION ESPECIALIDAD EMPLEO")
        break
      case "/misActosAdmin":
        setTitle("MIS ACTOS ADMINISTRATIVOS")
        break
      case "/hojaServiciosPrestados":
        setTitle("HOJA DE SERVICIOS PRESTADOS")
        break
      case "/nominaPDF":
        setTitle("NÓMINA")
        break
      case "/irpfPDF":
        setTitle("IRPF")
        break
      case "/variacionDatosPersonales":
        setTitle("VARIACIÓN DE DATOS PERSONALES")
        break
      case "/listadoactos":
        setTitle("TRÁMITES")
        break
      case "/irpfHabilitado":
        setTitle("IRPF HABILITADO")
        break 
      //DEFAULT por si se añade algun path nuevo y no se describe su título pondrá MI CARPETA
      default:
        setTitle("MI CARPETA")
        break
    }
  }, [path])
  
    return (
      <>
        <div className='div-banner-header' role="banner" data-landmark-index="1"> 
            <div className="container d-lg-flex justify-content-between align-items-center">
              <h1 className="div-banner-txt"> {title} </h1>
            </div>
        </div>
      </>
    )
}

export default Banner